//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { SCHEDULE_ITEM_TASK_NAME } from '@instagram-account/redux/account/instagramAccountModel';
import { EcommerceProvider } from '@models/MetricsGatewayApiModels';

export enum FACEBOOK_PAGE_ACTIONS {
  REQUEST_PAGE_ID = 'FACEBOOK/REQUEST_PAGE_ID',
  RECEIVE_PAGE_ID = 'FACEBOOK/RECEIVE_PAGE_ID',
  RECEIVE_EMPTY_PAGE_ID = 'FACEBOOK/RECEIVE_EMPTY_PAGE_ID',
  REQUEST_PAGE_METADATA = 'FACEBOOK/REQUEST_PAGE_METADATA',
  RECEIVE_PAGE_METADATA = 'FACEBOOK/RECEIVE_PAGE_METADATA',
  RECEIVE_ACCESS_STATE = 'FACEBOOK/RECEIVE_ACCESS_STATE',
  REQUEST_ACCESS_STATE = 'FACEBOOK/REQUEST_ACCESS_STATE',

  REQUEST_FB_IG_CONNECTION_INFO = 'FACEBOOK/REQUEST_FB_IG_CONNECTION_INFO',
  RECEIVE_FB_IG_CONNECTION_INFO_SUCCEEDED = 'FACEBOOK/RECEIVE_FB_IG_CONNECTION_INFO_SUCCEEDED',
  RECEIVE_FB_IG_CONNECTION_INFO_FAILED = 'FACEBOOK/RECEIVE_FB_IG_CONNECTION_INFO_FAILED',

  REQUEST_FACEBOOK_PAGE_CONNECTION_INFO = 'FACEBOOK/REQUEST_FACEBOOK_PAGE_CONNECTION_INFO',
  RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_SUCCEEDED = 'FACEBOOK/RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_SUCCEEDED',
  RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_FAILED = 'FACEBOOK/RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_FAILED',

  REQUEST_SET_IS_ONBOARDED = 'FACEBOOK/REQUEST_SET_IS_ONBOARDED',
  RECEIVE_SET_IS_ONBOARDED_SUCCEEDED = 'FACEBOOK/RECEIVE_SET_IS_ONBOARDED_SUCCEEDED',
  RECEIVE_SET_IS_ONBOARDED_FAILED = 'FACEBOOK/RECEIVE_SET_IS_ONBOARDED_FAILED',

  RECEIVE_TAGGED_PAGE = 'FACEBOOK_SCHEDULE/RECEIVE_TAGGED_PAGE',
  RECIEVE_GET_PAGE_BY_ID_FAILED = 'FACEBOOK_SCHEDULE/RECIEVE_GET_PAGE_BY_ID_FAILED',
}

export enum FACEBOOK_ONBOARDING_ACTIONS {
  REQUEST_AVAILABLE_PAGES = 'FACEBOOK_ONBOARDING/REQUEST_AVAILABLE_PAGES',
  RECEIVE_AVAILABLE_PAGES_SUCCEEDED = 'FACEBOOK_ONBOARDING/RECEIVE_AVAILABLE_PAGES_SUCCEEDED',
  RECEIVE_AVAILABLE_PAGES_FAILED = 'FACEBOOK_ONBOARDING/RECEIVE_AVAILABLE_PAGES_FAILED',

  REQUEST_UPDATE_CONNECTED_PAGE = 'FACEBOOK_ONBOARDING/REQUEST_UPDATE_CONNECTED_PAGE',
  RECEIVE_UPDATE_CONNECTED_PAGE_SUCCEEDED = 'FACEBOOK_ONBOARDING/RECEIVE_UPDATE_CONNECTED_PAGE_SUCCEEDED',
  RECEIVE_UPDATE_CONNECTED_PAGE_FAILED = 'FACEBOOK_ONBOARDING/RECEIVE_UPDATE_CONNECTED_PAGE_FAILED',

  UPDATE_ONBOARDING_SELECTED_PAGE_ID = 'FACEBOOK_ONBOARDING/UPDATE_ONBOARDING_SELECTED_PAGE_ID',
  UPDATE_ONBOARDING_CAROUSEL_STEP = 'FACEBOOK_ONBOARDING/UPDATE_ONBOARDING_CAROUSEL_STEP',
  UPDATE_IGNORE_DIFFERENT_PAGE = 'FACEBOOK_ONBOARDING/UPDATE_IGNORE_DIFFERENT_PAGE',
  UPDATE_ONBOARDING_CONFIRM_PAGE = 'FACEBOOK_ONBOARDING/UPDATE_ONBOARDING_CONFIRM_PAGE',
}

export enum FACEBOOK_SUMMARY_ACTIONS {
  GET_RECENT_POSTS = 'FACEBOOK_SUMMARY/GET_RECENT_POSTS',
  RECEIVE_RECENT_POSTS_SUCCEEDED = 'FACEBOOK_SUMMARY/RECEIVE_RECENT_POSTS_SUCCEEDED',
  RECEIVE_RECENT_POSTS_FAILED = 'FACEBOOK_SUMMARY/RECEIVE_RECENT_POSTS_FAILED',
  GET_SUMMARY_STATS = 'FACEBOOK_SUMMARY/GET_SUMMARY_STATS',
  RECEIVE_SUMMARY_STATS_SUCCEEDED = 'FACEBOOK_SUMMARY/RECEIVE_SUMMARY_STATS_SUCCEEDED',
  RECEIVE_SUMMARY_STATS_FAILED = 'FACEBOOK_SUMMARY/RECEIVE_SUMMARY_STATS_FAILED',
  UPDATE_SUMMARY_CHART_SERIES_OPTION = 'FACEBOOK_SUMMARY/UPDATE_SUMMARY_CHART_SERIES_OPTION',
}

export enum FACEBOOK_ENGAGEMENT_ACTIONS {
  GET_RECENT_POSTS = 'FACEBOOK_ENGAGEMENT/GET_RECENT_POSTS',
  RECEIVE_RECENT_POSTS_SUCCEEDED = 'FACEBOOK_ENGAGEMENT/RECEIVE_RECENT_POSTS_SUCCEEDED',
  RECEIVE_RECENT_POSTS_FAILED = 'FACEBOOK_ENGAGEMENT/RECEIVE_RECENT_POSTS_FAILED',
  GET_ENGAGEMENT_STATS = 'FACEBOOK_ENGAGEMENT/GET_ENGAGEMENT_STATS',
  RECEIVE_ENGAGEMENT_STATS_SUCCEEDED = 'FACEBOOK_ENGAGEMENT/RECEIVE_ENGAGEMENT_STATS_SUCCEEDED',
  RECEIVE_ENGAGEMENT_STATS_FAILED = 'FACEBOOK_ENGAGEMENT/RECEIVE_ENGAGEMENT_STATS_FAILED',

  RESET_POST_PAGINATION = 'FACEBOOK_ENGAGEMENT/RESET_POST_PAGINATION',

  UPDATE_DATE_RANGE = 'FACEBOOK_ENGAGEMENT/UPDATE_DATE_RANGE',
  UPDATE_CHART_SERIES_OPTION = 'FACEBOOK_ENGAGEMENT/UPDATE_CHART_SERIES_OPTION',
  UPDATE_POST_PAGINATION = 'FACEBOOK_ENGAGEMENT/UPDATE_POST_PAGINATION',
  UPDATE_POST_SORT = 'FACEBOOK_ENGAGEMENT/UPDATE_POST_SORT',

  REQUEST_BUBBLE_STATS = 'FACEBOOK_ENGAGEMENT/REQUEST_BUBBLE_STATS',
  RECEIVE_BUBBLE_STATS_SUCCEDED = 'FACEBOOK_ENGAGEMENT/RECEIVE_BUBBLE_STATS',
  RECEIVE_BUBBLE_STATS_FAILED = 'FACEBOOK_ENGAGEMENT/RECEIVE_BUBBLE_STATS_FAILED',

  REQUEST_GRAPH_STATS = 'FACEBOOK_ENGAGEMENT/REQUEST_GRAPH_STATS',
  RECEIVE_GRAPH_STATS_SUCCEDED = 'FACEBOOK_ENGAGEMENT/RECEIVE_GRAPH_STATS',
  RECEIVE_GRAPH_STATS_FAILED = 'FACEBOOK_ENGAGEMENT/RECEIVE_GRAPH_STATS_FAILED',
}

export enum FACEBOOK_AUDIENCE_ACTIONS {
  GET_AUDIENCE_STATS = 'FACEBOOK_AUDIENCE/GET_AUDIENCE_STATS',
  RECEIVE_AUDIENCE_STATS_SUCCEEDED = 'FACEBOOK_AUDIENCE/RECEIVE_AUDIENCE_STATS_SUCCEEDED',
  RECEIVE_AUDIENCE_STATS_FAILED = 'FACEBOOK_AUDIENCE/RECEIVE_AUDIENCE_STATS_FAILED',
  UPDATE_AGE_GENDER_OPTION = 'FACEBOOK_AUDIENCE/UPDATE_AGE_GENDER_OPTION',
  UPDATE_LOCATION_OPTION = 'FACEBOOK_AUDIENCE/UPDATE_LOCATION_OPTION',
  UPDATE_DATE_RANGE = 'FACEBOOK_AUDIENCE/UPDATE_DATE_RANGE',
}

export enum FACEBOOK_SCHEDULE_STEPS {
  POST_TYPE = 'post-type',
  POST_DETAILS = 'post-details',
  SUMMARY = 'summary',
}

export enum FACEBOOK_ROUTES {
  AUDIENCE = '/facebook/audience',
  ENGAGEMENT = '/facebook/engagement',
  SCHEDULE = '/facebook/schedule',
  SUMMARY = '/facebook/summary',
}

export enum FACEBOOK_POST_CONTENT_TYPES {
  IMAGE = 'image',
  VIDEO = 'video',
  LINK = 'link',
}

export enum FacebookApiPostTypes {
  PHOTO = 'Photo',
  VIDEO = 'Video',
  LINK = 'Link',
}

export enum FACEBOOK_SCHEDULE_POST_TYPES {
  SINGLE_IMAGE = 'single-image',
  SINGLE_VIDEO = 'single-video',
  MULTI_IMAGE = 'multi-image',
  LINK = 'link',
}

export const FacebookMediaSectionDisabledCtaTooltip = {
  VideoAdded: `You may only add one video at a time. If you'd like to add photos or a GIF, remove this video.`,
  GifAdded: `You may only add one GIF at a time. If you'd like to add photos or a video, remove this GIF.`,
} as const;

export const FACEBOOK_SQUARE_CROP_SIZE = 400;

export const FACEBOOK_POST_PREVIEW_MEDIA_WIDTH = 469;

export const PAGE_SEARCH_COUNT = 20;

export const VERIFIED_PAGE_STATUS = 'blue_verified';

export const FACEBOOK_BLUE = '#5064a1';

// Source: https://developers.facebook.com/docs/graph-api/reference/v10.0/photo#Creating
export const FACEBOOK_MAX_IMAGE_FILE_SIZE_MB = 10;
export const FACEBOOK_MAX_IMAGE_FILE_SIZE_BYTES =
  FACEBOOK_MAX_IMAGE_FILE_SIZE_MB * 1024 * 1024;
// Source: https://developers.facebook.com/docs/video-api/reference/error-codes
export const FACEBOOK_MAX_VIDEO_DURATION_MINUTES = 40;
export const FACEBOOK_MAX_VIDEO_DURATION_MILLIS =
  FACEBOOK_MAX_VIDEO_DURATION_MINUTES * 1000 * 60;

export const FACEBOOK_MAX_IMAGE_HEIGHT = FACEBOOK_POST_PREVIEW_MEDIA_WIDTH;

export const FACEBOOK_LINK_METADATA_MISSING_TRAY_HEIGHT = 80;

export enum FACEBOOK_SUPPORT_LINKS {
  SUMMARY = 'https://support.bazaarvoice.com/s/article/Facebook-Summary-Page-Overview',
  SCHEDULE = 'https://support.bazaarvoice.com/s/article/Facebook-Scheduler-Overview',
  AUDIENCE = 'https://support.bazaarvoice.com/s/article/Facebook-Audience-Overview',
  ENGAGEMENT = 'https://support.bazaarvoice.com/s/article/Facebook-Engagement-Overview',
}

export const FACEBOOK_PREFIX = 'facebook-';

const FACEBOOK_SCHEDULE_TRACKING_PREFIX = 'facebook-schedule';

export const FACEBOOK_SCHEDULE_TRACKING_IDS = {
  ADD_MEDIA: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_add-media`,
  ADD_ADDITIONAL_MEDIA: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_add-additional-media`,
  EDIT_MEDIA: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_edit-media`,
  CAPTION: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_caption`,
  CANCEL_POST: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_cancel-post`,
  EMOJI_PICKER: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_emoji-picker`,
  HASHTAG_LINK: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_hashtag-link`,
  LINK_SHORTENING_CHECKBOX: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_link-shortening-checkbox`,
  PAGE_TAG_LINK: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_page-tag-link`,
  SAVE_CHANGES: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_save-post-changes`,
  SCHEDULE_POST: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_schedule-post`,
  SAVE_DRAFT: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_save-draft`,
  SMART_INPUT: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_smart-input`,
  URL: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_url`,
  CALENDAR_ACTION_MENU: `${FACEBOOK_SCHEDULE_TRACKING_PREFIX}_action-menu`,
} as const;

const FACEBOOK_PAGE_TRACKING_PREFIX = 'facebook-page';

export const FacebookPageTrackingIds = {
  SCHEDULE_POST_BUTTON: `${FACEBOOK_PAGE_TRACKING_PREFIX}-schedule-post-button`,
  SUMMARY_DOWNLOAD_BUTTON: `${FACEBOOK_PAGE_TRACKING_PREFIX}-summary-download-button`,
};

export const FB_REVENUE_ENABLED_ECOMMERCE_PROVIDERS = [
  EcommerceProvider.GoogleAnalytics,
  EcommerceProvider.Demo,
];

/* Intentionally using the same permission as instagram scheduling */
export const FACEBOOK_SCHEDULE_ITEM_TASK_NAME = SCHEDULE_ITEM_TASK_NAME;

export const FACEBOOK_MAX_TEXT_LENGTH = 63000;
